import { billingAddressActions, useAppDispatch, useAppSelector } from '../../../data/store';
import { Popup } from '../../../../../../ui/popup/popup';
import React from 'react';

const TaxIdInfoPopup = () => {

    const dispatch = useAppDispatch();

    const countries = useAppSelector(store => store.root.countries);
    const countryIdControl = useAppSelector(store => store.billingAddress.countryIdControl);
    const selectedCountry = countries.find(country => country.countryID.toString() === countryIdControl.value.toString());
    const isTaxIdRequired = selectedCountry && selectedCountry.isTaxID;

    const closeHandler = () => {
        dispatch(
            billingAddressActions.main({
                taxIdPopupShown: false,
            })
        );
    };

    return (
        <Popup width="400px" height="270px" close={ closeHandler }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2 text-xl">What is Tax / VAT number?</p>
                <p className="mb-4">
                    <a className="inapp-hidden" href="https://en.wikipedia.org/wiki/VAT_identification_number" target="_blank" rel="noreferrer">Learn more about Tax / VAT number</a><br />

                    {
                        isTaxIdRequired &&
                        <span>
                        In accordance with tax regulations in your country, Waves is required to collect and remit GST if a valid Tax / VAT number was not entered during checkout.
                        </span>
                    }

                    {
                        !isTaxIdRequired &&
                        <span>
                        If you choose to enter your Tax / VAT number, it will be displayed on your invoice.
                        </span>
                    }
                </p>

                <button
                    type="button"
                    className="w-btn mt-2"
                    onClick={ closeHandler }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default TaxIdInfoPopup;